import React, { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  // Hide on canino4-9 (custom hero pages)
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const isCanino9 = path.includes('canino4') || path.includes('canino5') || path.includes('canino6') || path.includes('canino7') || path.includes('canino8') || path.includes('canino9');
  useEffect(() => {
    if (isCanino9) return;
    function checkVisibility() {
      const start = document.getElementById('protocol-intro');
      const end = document.getElementById('written-testimonials');
      if (!start || !end) {
        setVisible(false);
        return;
      }
      const startRect = start.getBoundingClientRect();
      const endRect = end.getBoundingClientRect();
      const hasReachedStart = startRect.top < window.innerHeight * 0.7;
      const endStillVisible = endRect.bottom > 0;
      setVisible(hasReachedStart && endStillVisible);
    }
    window.addEventListener('scroll', checkVisibility, {
      passive: true
    });
    checkVisibility();
    return () => window.removeEventListener('scroll', checkVisibility);
  }, [isCanino9]);
  if (isCanino9) return null;
  return <div className={`fixed top-0 left-0 right-0 z-[55] transition-transform duration-400 ${visible ? 'translate-y-0' : '-translate-y-full'}`} data-id="element-114">
      <div className="w-full px-3 py-2.5" style={{
      background: 'linear-gradient(to right, #2F5D50, #3d7a68)'
    }} data-id="element-115">
        <button onClick={() => {
        document.getElementById('benefits-section')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }} className="group w-full max-w-xl mx-auto flex items-center justify-center gap-2 text-white font-bold py-2.5 px-6 rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden" style={{
        background: 'linear-gradient(to right, #F57C00, #e07000)',
        boxShadow: '0 4px 16px rgba(245,124,0,0.4)'
      }} data-id="element-116">
          <span className="pointer-events-none absolute inset-0" style={{
          background: 'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.3) 50%, transparent 60%)',
          animation: 'floatingShimmer 2.5s linear infinite'
        }} data-id="element-117" />
          <ShieldCheck className="w-5 h-5 relative z-10 flex-shrink-0" data-id="element-118" />
          <span className="relative z-10 text-sm sm:text-base tracking-wide uppercase" data-id="element-119">
            QUIERO SALVAR LA VIDA DE MI MASCOTA
          </span>
          <style data-id="element-120">{`
            @keyframes floatingShimmer {
              0% { transform: translateX(-100%); }
              100% { transform: translateX(200%); }
            }
          `}</style>
        </button>
      </div>
    </div>;
}